import BrandingThemeDetailsHeaderButtons from '@/components/brandingThemes/BrandingThemeDetailsHeaderButtons';
import BrandingThemeForm from '@/components/brandingThemes/form/BrandingThemeForm';
import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { useGetBrandingThemeDetails } from '@/hooks/requests/useBrandingThemes';
import { Card, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function BrandingThemeEdit() {
  const { brandingThemeId = '' } = useParams();
  const { brandingTheme, isBrandingThemePending } =
    useGetBrandingThemeDetails(brandingThemeId);

  if (isBrandingThemePending) {
    return (
      <DefaultLayout header="">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!brandingTheme) {
    return (
      <DefaultLayout header="">
        <Card>
          <Typography>
            Something went wrong retreiving the branding theme. Our team has
            been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header={`Edit ${brandingTheme.name}`}
      buttons={[
        <BrandingThemeDetailsHeaderButtons
          key="header"
          brandingTheme={brandingTheme}
          showEdit={false}
        />,
      ]}>
      <BrandingThemeForm defaultValues={brandingTheme} />
    </DefaultLayout>
  );
}
